//====================================================
//  Function: Reposition Advanced modal
//====================================================

function repositionContentAdvancedModal() {
  $("#colorbox").removeClass("is-advanced-modal");
  if ($(".advanced-order").length) {
    $("#colorbox").addClass("is-advanced-modal");
    // $('#cboxClose').addClass('cboxClose--order')
    // $('#colorbox').addClass('colorbox--order')
  }
}
